import { leafletToMapboxGeoFenceStyle } from 'frontend/live-panel/helpers/leaflet-to-mapbox-adapters'

export const stagingAreaGeoFenceStyle = {
  fillColor: '#008f37',
  fillOpacity: 0.15,
  strokeColor: '#008f37',
  strokeWeight: 1,
  strokeOpacity: 0.8,
}

export const mapBoxStagingAreaGeoFenceStyle = leafletToMapboxGeoFenceStyle(stagingAreaGeoFenceStyle)
